export type AppLanguage = 'he' | 'en';

/** Collapses any language identifier to one of the two codes the app actually
 *  supports. i18next's fallbackLng ('he') serves Hebrew TEXT for any unknown
 *  code, but layout direction switches only on the exact code — so a stray
 *  'he-IL' / legacy 'iw' / 'HE' in localStorage or user.language rendered
 *  Hebrew text in an LTR layout. Normalize at every boundary instead. */
export const normalizeLanguage = (value: string | null | undefined): AppLanguage | null => {
    if (!value) return null;
    const lower = value.toLowerCase();
    if (lower === 'he' || lower === 'iw' || lower.startsWith('he-') || lower.startsWith('iw-')) return 'he';
    if (lower === 'en' || lower.startsWith('en-')) return 'en';
    return null;
};
